export default "__VITE_ASSET__D8ypSuo3__"